import Typography from "@mui/material/Typography";
import {alpha, Grid, IconButton, Link} from "@mui/material";
import genie_logo from '../../assets/images/logo.svg'
import useFooterLinks from "./useFooterLinks";
import FooterLinks from "./FooterLinks";
import {useTranslation} from "react-i18next";
import * as React from "react";
import ReactGA from "react-ga4";
import {useTheme} from "@mui/material/styles";
import useSocialMedia from "../../hooks/useSocialMedia";

const Footer = () => {
    const {exploreMore, help, legal} = useFooterLinks()
    const {t} = useTranslation()
    const theme = useTheme()
    const {socialMedia} = useSocialMedia()

    const handleOnSocialMediaClick = (label: string) => {
        ReactGA.event({
            category: 'Social Links',
            action: 'social_link_click',
            label,
        })
    }

    return (
        <Grid container spacing={3} component="footer" p="0 1em 24px 1em" sx={{
            backgroundColor: alpha(theme.palette.secondary.main, .6),
            backdropFilter: "blur(5px)",
            mt: {xs: '3em', sm: '2.5em'}
        }}>
            <Grid item xs={12} sm={5} container justifyContent='center'>
                <img src={genie_logo} alt='logo' width={100}/>
                <Grid container justifyContent='center' sx={{my: 1}}>
                    {socialMedia.map((sm) => (
                        <IconButton key={sm.label} color='primary' onClick={() => handleOnSocialMediaClick(sm.label)}
                                    component={Link} href={sm.link} target="_blank" rel="noopener noreferrer">
                            {sm.icon}
                        </IconButton>
                    ))}
                </Grid>
                <Typography variant="body1" color="primary" textAlign="center">
                    &copy; Genie {new Date().getFullYear()}, {t('all_rights_reserved')}
                </Typography>
            </Grid>
            <Grid item container spacing={2} justifyContent='space-evenly' xs={12} sm={7}>
                <FooterLinks footerLinks={exploreMore}/>
                <FooterLinks footerLinks={help}/>
                <FooterLinks footerLinks={legal}/>
            </Grid>
        </Grid>
    )
}

export default Footer
